import { useState, useEffect } from 'react';
import supabase from '../lib/supabase';

export default function Leaderboard() {
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const oneWeekAgo = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
      const { data } = await supabase
        .from('mock_exam_scores')
        .select('email, score, created_at')
        .gte('created_at', oneWeekAgo)
        .order('score', { ascending: false })
        .limit(10);
      setScores(data || []);
      setLoading(false);
    }
    load();
  }, []);

  function maskEmail(email) {
    if (!email) return 'Anonymous';
    const [local, domain] = email.split('@');
    return local.slice(0, 2) + '***@' + domain;
  }

  const medals = ['🥇', '🥈', '🥉'];

  return (
    <div className="leaderboard">
      <h2 className="leaderboard-title">Weekly Leaderboard</h2>
      <p className="leaderboard-sub">Top mock exam scores this week</p>

      {loading && (
        <div className="loading-box">
          <div className="spinner" />
          <p>Loading scores…</p>
        </div>
      )}

      {!loading && scores.length === 0 && (
        <p className="leaderboard-empty">No scores yet this week. Take the mock exam to claim the top spot!</p>
      )}

      {!loading && scores.length > 0 && (
        <div className="leaderboard-list">
          {scores.map((s, i) => (
            <div key={i} className={`leaderboard-row ${i === 0 ? 'leaderboard-row--first' : ''}`}>
              <span className="leaderboard-rank">{medals[i] || `#${i + 1}`}</span>
              <span className="leaderboard-email">{maskEmail(s.email)}</span>
              <span className="leaderboard-score">{s.score}%</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
